import { Component, ElementRef, Inject, PLATFORM_ID } from '@angular/core';
import { PagesHeaderComponent } from '../../components/pages-header/pages-header.component';
import { BuyerFooterComponent } from '../../../../Shared/components/buyer-footer/buyer-footer.component';
import { Breadcrumb } from 'src/app/Shared/_models/breadcrumb.model';
import { BreadCrumbsComponent } from '../../../../Shared/components/bread-crumbs/bread-crumbs.component';
import { ContactUsFormComponent } from '../../components/contact-us-form/contact-us-form.component';
import { isPlatformBrowser, NgStyle } from '@angular/common';
import { FormBuilder } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { TranslatePipe, TranslateService} from '@ngx-translate/core';
import { ToastService } from 'src/app/Shared/services/toast/toast.service';
import { LocaleService } from 'src/app/Shared/services/locale/locale.service';

import { LandingService } from '../../_services/landing.service';

@Component({
    selector: 'app-contact',
        standalone: true,
imports: [BreadCrumbsComponent, ContactUsFormComponent,
        TranslatePipe, NgStyle
    ],
    templateUrl: './contact.component.html',
    styleUrl: './contact.component.scss'
})
export class ContactComponent {
  breadcrumbs: Breadcrumb[] = [];
  isBrowser: any;
  currentLang: any;
  loggedIn = false;

  constructor(
    private titleService: Title,
    @Inject(PLATFORM_ID) private platformId: any,
    private homeService: LandingService,
    private toastService: ToastService,
    private translate: TranslateService,
    private fb: FormBuilder,
    private el: ElementRef
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit() {
    if (this.isBrowser) {
      this.currentLang = this.translate.currentLang || this.translate.getDefaultLang();
    }
  }
}
